<template>
  <SectionFrame v-if="people.length || inStudio" :section="section" :index="index" :heading="heading" label="Meet the team">
    <ul v-if="people.length" :class="layout === 'list' ? 's2-team-list' : 's2-team-grid'" class="mo-stagger">
      <li v-for="p in people" :key="p.id">
        <img v-if="p.photo" :src="p.photo" v-bind="imgAttrs(p.photo, '(min-width: 1024px) 25vw, 50vw')" :alt="p.name" class="t-photo s2-face" loading="lazy">
        <span v-else class="s2-face s2-face--blank" aria-hidden="true">{{ initials(p.name) }}</span>
        <div>
          <h3 class="t-h3 s2-person">{{ p.name }}</h3>
          <p v-if="section.showRole !== false && p.title" class="s2-muted">{{ p.title }}</p>
          <p v-if="section.showBio !== false && p.bio" class="t-body s2-bio">{{ p.bio }}</p>
        </div>
      </li>
    </ul>
    <StudioGap v-else>Choose who shows on your website (Team), then they show here.</StudioGap>
  </SectionFrame>
</template>

<script setup>
import {computed} from "vue";
import {imgAttrs} from "@/utils/photoSizes.js";
import SectionFrame from "./SectionFrame.vue";
import StudioGap from "./StudioGap.vue";
import {layoutOf, pickPeople} from "@/utils/sectionLogic.js";
import {studioMode} from "@/classes/previewBridge.js";

const props = defineProps({section: {type: Object, required: true}, index: {type: Number, default: 0}, data: {type: Object, default: () => ({})}});
const inStudio = computed(() => studioMode.value !== "off");
const layout = computed(() => layoutOf(props.section, ["grid", "list"]));
const heading = computed(() => props.section.heading ?? "Meet the team");
const people = computed(() => pickPeople(props.data.team, props.section));
const initials = (n) => String(n || "").split(/\s+/).map((w) => w[0] || "").join("").slice(0, 2).toUpperCase();
</script>

<style>
.s2-team-grid { list-style: none; padding: 0; margin: 0; display: grid; gap: var(--t-gap); grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); }
.s2-team-grid .s2-face { width: 100%; height: auto; aspect-ratio: 4 / 5; }
.s2-team-list { list-style: none; padding: 0; margin: 0; display: grid; gap: var(--t-gap); }
.s2-team-list li { display: grid; grid-template-columns: 96px 1fr; gap: 1.25rem; align-items: start; }
.s2-team-list .s2-face { width: 96px; height: 96px; }
.s2-face { display: block; object-fit: cover; }
.s2-face--blank { box-sizing: border-box; border: 1px solid var(--t-line); display: flex; align-items: center; justify-content: center; background: var(--t-surface-2); color: var(--t-muted); font: 700 1.5rem var(--t-font-display); border-radius: var(--t-photo-radius); }
.s2-person { margin: .75rem 0 .15rem; }
.s2-team-list .s2-person { margin-top: 0; }
.s2-bio { margin: .4rem 0 0; }
</style>
